export default __webpack_public_path__ + "static/media/q5_step2.0e25b40f.png";